<!--
 * @Author: Haoxiwei 1078734933@qq.com
 * @Date: 2023-07-27 09:24:27
 * @LastEditors: Haoxiwei 1078734933@qq.com
 * @LastEditTime: 2024-12-24 10:28:29
 * @FilePath: /wemeet-admin-new/src/views/brand/index.vue
 * @Description:
 * Copyright (c) 2023 by WeMeet, All Rights Reserved.
-->
<template>
  <div>
    <el-tabs v-model="activeName" class="demo-tabs" @tab-click="handleClick">
      <el-tab-pane label="机构列表管理" name="first">
        <BrandList ref="brandList" />
      </el-tab-pane>
      <el-tab-pane label="机构信息库" name="second">
        <vab-query-form>
          <vab-query-form-left-panel :span="12">
            <el-button :icon="Plus" type="primary" @click="addBrand($event)">
              {{ queryForm.meetingType == 'EXHIBITION' ? '添加展商' : '添加机构' }}
            </el-button>
            <el-button type="success" @click="importBrand($event)">
              {{ queryForm.meetingType == 'EXHIBITION' ? '批量导入展商' : '批量导入机构' }}
            </el-button>
            <el-button type="success" @click="importProductBrand($event)">
              {{ queryForm.meetingType == 'EXHIBITION' ? '批量导入展品' : '批量导入产品' }}
            </el-button>
            <el-button type="success" @click="importResult($event)">导入结果</el-button>

            <el-button v-if="chooseVal.length > 0" type="success" @click="batchStatus(true)">批量上架</el-button>
            <el-button v-if="chooseVal.length > 0" type="danger" @click="batchStatus(false)">批量下架</el-button>
            <el-button v-if="chooseVal.length > 0" type="success" @click="batchEnterprise(true)">
              批量更新机构荟客厅
            </el-button>
            <el-button v-if="chooseVal.length > 0" type="success" @click="batchEnterpriseProduct(true)">
              批量更新机构产品
            </el-button>
            <el-button type="success" @click="batchExportPoster()">
              {{ queryForm.meetingType == 'EXHIBITION' ? '批量下载展商海报' : '批量下载机构海报' }}
            </el-button>
          </vab-query-form-left-panel>
          <vab-query-form-right-panel :span="12">
            <el-form :inline="true" :model="queryForm" @submit.prevent>
              <el-form-item>
                <el-input v-model.trim="queryForm.likeExhibitorName" clearable placeholder="请输入名称" />
              </el-form-item>
              <el-form-item>
                <el-button :icon="Search" type="primary" @click="queryData">查询</el-button>
              </el-form-item>
            </el-form>
          </vab-query-form-right-panel>
        </vab-query-form>
        <el-table v-loading="listLoading" border :data="list" @selection-change="handleSelectionChange">
          <el-table-column type="selection" width="55" />
          <el-table-column
            :label="queryForm.meetingType == 'EXHIBITION' ? '展商名称' : '机构名称'"
            prop="exhibitorName"
            show-overflow-tooltip
          />
          <el-table-column
            :label="queryForm.meetingType == 'EXHIBITION' ? '展品数量' : '产品数量'"
            prop="exhibitNum"
            show-overflow-tooltip
          />
          <el-table-column label="排序值" prop="sort" show-overflow-tooltip />
          <el-table-column label="创建时间" prop="createTime" show-overflow-tooltip />
          <el-table-column label="状态" prop="status" show-overflow-tooltip>
            <template #default="{ row }">
              <el-switch
                v-model="row.status"
                active-text="上线"
                inactive-text="下线"
                size="large"
                @change="shopStatusChange(row)"
              />
            </template>
          </el-table-column>
          <el-table-column label="操作" show-overflow-tooltip width="520">
            <template #default="{ row }">
              <el-button plain type="info" @click="handleEdit(row)">编辑</el-button>
              <el-button v-loading.fullscreen.lock="fullscreenLoading" plain type="info" @click="handlePoster(row)">
                渠道海报
              </el-button>
              <el-button plain type="info" @click="handleProduct(row)">
                {{ queryForm.meetingType == 'EXHIBITION' ? '展品管理' : '产品管理' }}
              </el-button>
              <el-button plain type="info" @click="handleShare(row)">分享</el-button>
              <el-button plain type="info" @click="handleSort(row)">调整排序</el-button>
              <el-button plain type="danger" @click="handleDelete(row)">删除</el-button>
            </template>
          </el-table-column>
          <template #empty>
            <!-- <el-image
          class="vab-data-empty"
          :src="require('@/assets/empty_images/data_empty.png')"
        /> -->
            <el-empty class="vab-data-empty" description="暂无数据" />
          </template>
        </el-table>
        <el-pagination
          background
          :current-page="queryForm.pageNumber"
          :layout="layout"
          :page-size="queryForm.pageSize"
          :total="total"
          @current-change="handleCurrentChange"
          @size-change="handleSizeChange"
        />
      </el-tab-pane>
    </el-tabs>

    <edit-sort ref="editRef" @fetch-data="fetchData" />
    <qrCode-preview ref="previewDialog" :url="previewQrcode" :website="previewWebSite" />

    <upload-file ref="upLoadRef" :meeting-code="queryForm.meetingCode" @fetch-data="queryData" />
    <product-upload ref="productUploadRef" :meeting-code="queryForm.meetingCode" @fetch-data="queryData" />
    <upload-result ref="resultRef" :meeting-code="queryForm.meetingCode" />

    <export-poster ref="exportPosterRef" />

    <el-dialog
      v-model="dialogVisible"
      style="width: 200px"
      :title="queryForm.meetingType == 'EXHIBITION' ? '展商渠道海报' : '机构渠道海报'"
    >
      <div style="width: 100%; display: flex; align-items: center; justify-content: center">
        <img alt="" :src="posterUrl" width="300" />
      </div>
      <template #footer>
        <div class="dialog-footer" style="display: flex; align-items: center; justify-content: center">
          <el-button type="primary" @click="downLoadImg">
            {{ queryForm.meetingType == 'EXHIBITION' ? '下载展商渠道海报' : '下载机构渠道海报' }}
          </el-button>
        </div>
      </template>
    </el-dialog>
  </div>
</template>

<script>
  import { defineComponent, defineAsyncComponent, getCurrentInstance, reactive, toRefs, onActivated } from 'vue'

  import { Delete, Plus, Search } from '@element-plus/icons'
  import {
    getBrandList,
    editBrandStatus,
    deleteBrand,
    batchUpDateExhibitor,
    exhibitorSyncErToEn,
    syncExibitToProduct,
    downloadPoster,
  } from '@/api/brand'
  import { useRoute } from 'vue-router'
  import qrCodePreview from '@/components/qrCodePreview'
  import { downloadImageByUrl } from '@/utils/download'

  export default defineComponent({
    name: 'Brand',
    components: {
      EditSort: defineAsyncComponent(() => import('./components/editSort')),
      uploadFile: defineAsyncComponent(() => import('./components/visitorImport')),
      productUpload: defineAsyncComponent(() => import('./components/productImport')),
      uploadResult: defineAsyncComponent(() => import('./components/uploadResult')),
      exportPoster: defineAsyncComponent(() => import('./components/exportPoster')),
      qrCodePreview,
      BrandList: defineAsyncComponent(() => import('./brandList')),
    },
    setup() {
      const { proxy } = getCurrentInstance()
      const route = useRoute()
      const state = reactive({
        queryForm: {
          likeExhibitorName: '',
          pageNum: 1,
          pageSize: 10,
          meetingCode: route.query.meetingCode,
        },
        activeName: 'first',
        exportPosterRef: null,
        total: 0,
        listLoading: false,
        list: [],
        layout: 'total, sizes, prev, pager, next, jumper',
        editRef: null,
        previewDialog: null,
        previewQrcode: '',
        previewWebSite: '',
        upLoadRef: null,
        resultRef: null,
        productUploadRef: null,
        chooseVal: [],
        fullscreenLoading: false,
        dialogVisible: false,
        posterUrl: '',
        checkRow: {},
      })

      /**
       * @description: 编辑展商
       * @param {*} row
       * @return {*}
       */
      const handleEdit = (row) => {
        proxy.$router.push({
          path: '/exhibitionManage/brandEdit',
          query: {
            meetingCode: state.queryForm.meetingCode,
            id: row.exhibitorCode,
            industryType: row.industryType,
            meetingType: state.queryForm.meetingType,
          },
        })
      }

      const handleConfig = (row) => {
        proxy.$router.replace(`/page/pageConfigModule/${row.id}`)
      }

      const handleDelete = (row) => {
        if (row.exhibitorCode) {
          proxy.$baseConfirm('你确定要删除当前项吗', null, async () => {
            const { msg } = await deleteBrand({
              exhibitorCode: row.exhibitorCode,
              meetingCode: state.queryForm.meetingCode,
            })
            proxy.$baseMessage(`操作成功`, 'success', 'vab-hey-message-success')
            await fetchData()
          })
        }
      }

      const queryData = () => {
        fetchData()
      }

      const fetchData = async () => {
        state.listLoading = true
        state.queryForm.meetingCode = route.query.meetingCode
        state.queryForm.meetingType = route.query.meetingType
        const { data } = await getBrandList(state.queryForm)
        state.list = data.list
        state.total = data.total
        state.listLoading = false
      }

      const handleSizeChange = (val) => {
        state.queryForm.pageSize = val
        fetchData()
      }
      const handleCurrentChange = (val) => {
        state.queryForm.pageNum = val
        fetchData()
      }

      const shopStatusChange = async (row) => {
        try {
          let obj = {
            status: row.status,
            exhibitorCode: row.exhibitorCode,
          }
          await editBrandStatus(obj)
          proxy.$baseMessage(`操作成功`, 'success', 'vab-hey-message-success')
        } catch (e) {
          proxy.$baseMessage(`操作失败`, 'error', 'vab-hey-message-error')
          console.log(e)
        }

        fetchData()
      }

      onActivated(() => {
        fetchData()
      })

      const addBrand = () => {
        proxy.$router.push({
          path: '/exhibitionManage/brandEdit',
          query: {
            meetingCode: state.queryForm.meetingCode,
            id: 'new',
            meetingType: state.queryForm.meetingType,
          },
        })
      }

      const handleProduct = (row) => {
        let query = {
          exhibitorCode: row.exhibitorCode,
          industryType: row.industryType,
          meetingCode: state.queryForm.meetingCode,
          meetingType: state.queryForm.meetingType,
        }
        console.log(row, 'row')
        if (row.enterpriseCode) {
          query.enterpriseCode = row.enterpriseCode
        } else if (row.exhibitorCode) {
          query.exhibitorCode = row.exhibitorCode
        }
        proxy.$router.push({
          path: '/exhibitionManage/brandProduct',
          query,
        })
      }

      const handleSort = (row) => {
        state.editRef.showEdit(row)
      }
      const importBrand = () => {
        state.upLoadRef.showEdit({
          title: state.queryForm.meetingType == 'EXHIBITION' ? '批量导入展商' : '批量导入机构',
        })
      }
      const importProductBrand = () => {
        state.productUploadRef.showEdit({
          title: state.queryForm.meetingType == 'EXHIBITION' ? '批量导入展品' : '批量导入产品',
        })
      }
      const importResult = () => {
        state.resultRef.showEdit()
      }

      const handleShare = (row) => {
        state.previewWebSite = row.exhibitorH5Url
        state.previewQrcode = row.exhibitorQrcode
        state.previewDialog.handleOpen()
      }

      const handleSelectionChange = (val) => {
        state.chooseVal = val
      }

      const batchStatus = (status) => {
        console.log(state.chooseVal)
        let params = {
          exhibitorCode: state.chooseVal.map((v) => v.exhibitorCode),
          status,
        }
        batchUpDateExhibitor(params).then((res) => {
          fetchData()
        })
      }

      const batchEnterprise = (status) => {
        console.log(state.chooseVal)
        let params = {
          params: state.chooseVal.map((v) => v.exhibitorCode),
        }
        exhibitorSyncErToEn(params).then((res) => {
          fetchData()
        })
      }
      const batchEnterpriseProduct = (status) => {
        console.log(state.chooseVal)
        let params = {
          params: state.chooseVal.map((v) => v.exhibitorCode),
        }
        syncExibitToProduct(params).then((res) => {
          fetchData()
        })
      }

      const batchExportPoster = async () => {
        let params = {
          params: state.chooseVal.map((v) => v.exhibitorCode),
          code: state.queryForm.meetingCode,
          relationType: 'EXHIBITION',
          title: state.queryForm.meetingType == 'EXHIBITION' ? '批量下载展商海报' : '批量下载机构海报',
        }
        state.exportPosterRef.handleOpen(params, `主办渠道`, `MEETING_EXHIBITOR_RELAY_POSTER`)
      }

      const handlePoster = async (row) => {
        console.log(row)
        state.checkRow = row
        state.fullscreenLoading = true
        const { data } = await downloadPoster({
          erCode: row.exhibitorCode,
          meetingCode: state.queryForm.meetingCode,
        })

        state.fullscreenLoading = false

        state.dialogVisible = true
        state.posterUrl = data
      }

      function downLoadImg() {
        downloadImageByUrl(state.posterUrl, state.checkRow.exhibitorName)
      }

      return {
        ...toRefs(state),
        handleEdit,
        queryData,
        fetchData,
        handleSizeChange,
        handleCurrentChange,
        handleDelete,
        shopStatusChange,
        importProductBrand,
        handleConfig,
        Delete,
        Search,
        Plus,
        addBrand,
        handleSort,
        handleProduct,
        handleShare,
        importResult,
        importBrand,
        handleSelectionChange,
        batchStatus,
        batchEnterprise,
        batchEnterpriseProduct,
        batchExportPoster,
        handlePoster,
        downLoadImg,
      }
    },
  })
</script>
<style lang="scss" scoped></style>
